export default "__VITE_ASSET__DJufhry1__"